import React from 'react';
const style ={
  width:"40px",
  height:"40px"
}
const SingleCategory = (props) => {
  const { itemClass, icon, title } = props;

  return (
    <div
      className={
        itemClass
          ? itemClass
          : 'ed-category-item ed-category-style-1 d-flex align-items-center mb-35'
      }
    >
      <div className="ed-category-icon">
        <span>
            <img src={icon} alt=""  style={style}/>
        </span>
      </div>
      <h4 className="ed-category-title">
        {title ? title : 'Business Management'}
      </h4>
    </div>
  );
};
export default SingleCategory;
